import React from 'react'
import { toast } from 'react-toastify'
import { getErrorMessage } from '@/utils/errorMessages'
//import "react-toastify/dist/ReactToastify.css";

// Start a new toast and save its ID
export const startNotif = (message) => {
  return toast(message, {
    autoClose: false,
    type: 'info',
    position: 'bottom-right',
    isLoading: true,
    progressStyle: { backgroundColor: '#69A455' },
    toastClassName: 'rounded-md',
    //progress: 50
  })
}

// Update Notification
export const updateNotif = (toastId, newMessage, progress) => {
  // Update the toast's text
  toast.update(toastId, {
    type: 'info',
    render: newMessage,
    autoClose: false,
    progress: progress || undefined,
    progressStyle: { backgroundColor: '#69A455' },
    toastClassName: 'rounded-md',
  })
}

// Update and auto-close the toast
export const closeNotif = (toastId, finalMessage, config = {}) => {
  const autoCloseTime = config.autoCloseTime || 3000
  toast.update(toastId, {
    render: config.type === 'error' ? getErrorMessage(finalMessage) : finalMessage,
    type: 'success',
    autoClose: autoCloseTime,
    isLoading: false,
    progressStyle: config.type === 'error' ? { backgroundColor: '#F04438' } : { backgroundColor: '#69A455' },
    toastClassName: 'rounded-md',
    progress: undefined,
    ...config,
  })
}
